import { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Card,
    message,
    Input,
    Switch,
    Button,
    Form,
    Modal,
    Checkbox,
    InputNumber,
    ColorPicker,
    Select,
    Typography
} from "../ui/ot";
import ClassifyStructureNew from "../classify/views/Main";
import { usePageManagement } from './controller/page_management_controller'
import { useSearchParams } from "react-router-dom";
import { useMenu } from "./controller/menu_controller";
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce(
        (all, [key, value]) =>
            (value === "" || value === null || value === undefined) ? { ...all } : { ...all, [key]: value },
        {}
    );
};
const RouteSetting = ({ prefixTitle = "", self = false }) => {
    const [searchParams] = useSearchParams()
    const { menu_id } = Object.fromEntries([...searchParams])
    const [form] = Form.useForm();
    const [count, setCount] = useState(0)
    const current_menu_id = useRef(menu_id)
    const [selectCurrentMenuId, setSelectCurrentMenuId] = useState(menu_id)
    const [forceReload, setForceReload] = useState(0)

    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || "";
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const formItemsRender = () => {
        return (
            <Row>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"permission_id"}
                        name="permission_id"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"classify_structure_id"}
                        name="classify_structure_id"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"classify_structure_type_parent_id"}
                        name="classify_structure_type_parent_id"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        hidden={true}
                        label={"classify_structure_type_id"}
                        name="classify_structure_type_id"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label={"英文名稱"} name="nameEn">
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24} hidden >
                    <Form.Item label={"path_check"} name="path_check">
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label={"連結"} name="path_check_replace">
                        <Switch
                            checkedChildren="外部連結"
                            unCheckedChildren="內部連結"
                            onChange={(e) => {
                                let newValue = e.target.value ? 1 : 0
                                setFieldValue("path_check", newValue)
                                setCount(pre => pre + 1)
                            }}
                        />
                    </Form.Item>
                </Col>
                {getAnyFormValue("path_check_replace", count) ? (
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    label={"連結"}
                                    name="path"

                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item hidden={true} label={"blank"} name="blank">
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label={"另開分頁"} name="blank_replace">
                                    <Switch
                                        checkedChildren="是"
                                        unCheckedChildren="否"
                                        onChange={(e) => {
                                            let newValue = e.target.value ? 1 : 0
                                            setFieldValue("blank", newValue)
                                            setCount(pre => pre + 1)
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                ) : (
                    <Col span={24}>
                        <Row>
                            <Col
                                span={24}
                                hidden={true}

                            >
                                <Form.List
                                    name={`permission_page_data`}
                                // hidden={ !propertyJsonShow ? false : !propertyJsonShow[ "blog_news_data" ]  }
                                >
                                    {(
                                        permissionPageFields
                                    ) => (
                                        // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                        <>
                                            {permissionPageFields.map((
                                                permissionPageField
                                            ) => (
                                                <>
                                                    <Form.Item
                                                        // hidden
                                                        name={[
                                                            permissionPageField.name,
                                                            "page_id",
                                                        ]}
                                                    >
                                                        <Input />
                                                    </Form.Item>

                                                </>
                                            )
                                            )}
                                        </>
                                    )}
                                </Form.List>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[8, 16]} align="middle">
                                    <Col span={8}>
                                        <Row justify={"end"}>
                                            <Col>
                                                頁面：
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={16}>
                                        <Select
                                            name={"test"}
                                            value={getAnyFormValue('permission_page_data.0.page_id', count) || null}
                                            options={(
                                                PageManagementData ||
                                                []
                                            ).map(
                                                (
                                                    value
                                                ) => {
                                                    return {
                                                        label: getLanguageName(
                                                            {
                                                                language_culture_code:
                                                                    "zh-tw",
                                                                obj_language_data:
                                                                    value?.name_language_data,
                                                            }
                                                        ),
                                                        value: value?.page_id,
                                                    };
                                                }
                                            )}
                                            onChange={(e) => {
                                                let permission_page_data = getAnyFormValue("permission_page_data", count)
                                                if (permission_page_data.length > 0) {
                                                    permission_page_data = permission_page_data?.map((element) => {
                                                        return {
                                                            page_id: e.target.value
                                                        }
                                                    })
                                                }
                                                else {
                                                    permission_page_data = [
                                                        {
                                                            page_id: e.target.value,
                                                        }
                                                    ]
                                                }

                                                setCount(pre => pre + 1)
                                                setFieldValue("permission_page_data", permission_page_data)
                                            }}
                                        />
                                    </Col>
                                    <Col span={24}>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                )}
                <Col span={24} hidden={true}>
                    <Form.Item
                        label={"顯示(副)標題"}
                        name="show"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"顯示(副)標題"}
                        name="show_replace"
                    >
                        <Switch
                            checkedChildren="顯示"
                            unCheckedChildren="不顯示"
                            onChange={(e) => {
                                let newValue = e.target.value ? 1 : 0
                                setFieldValue("show", newValue)
                                setCount(pre => pre + 1)
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label={"副標題"} name="subheading">
                        <Input
                        // value={modalData?.data?.subheading} 
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"字體大小"}
                        name={`property_json.size`}
                    >
                        <InputNumber
                            type="number"
                            max="100"
                            onChange={(val) => {
                                setCount(pre => pre + 1)
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={24} hidden={true}>
                    <Form.Item
                        label={"粗體"}

                        name={`property_json.blod`}
                    >
                        <Switch
                            onChange={(e) => {
                                setCount(pre => pre + 1)
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"斜體"}
                        name={`property_json.italic`}
                    >
                        <Switch
                            onChange={(e) => {
                                setCount(pre => pre + 1)
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"粗體"}
                        name={`property_json.textDecoration`}
                    >
                        <Switch
                            onChange={(e) => {
                                setCount(pre => pre + 1)
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        style={{ margin: 0, padding: 0 }}
                        label={"字體效果"}
                        name="property_json"
                    >
                        <Row gutter={[8, 8]} style={{ margin: 0, padding: 0 }}>
                            <Col>
                                <Checkbox
                                    checked={getAnyFormValue("property_json.blod", count)}
                                    onCheckedChange={(val) => {
                                        let property_json = getAnyFormValue("property_json", count)
                                        setFieldValue("property_json", {
                                            ...property_json,
                                            blod: val
                                        })
                                        setCount(pre => pre + 1)
                                    }}
                                >
                                    粗體
                                </Checkbox>
                            </Col>
                            <Col>
                                <Checkbox
                                    checked={getAnyFormValue("property_json.italic", count)}
                                    onCheckedChange={(val) => {
                                        let property_json = getAnyFormValue("property_json", count)
                                        setFieldValue("property_json", {
                                            ...property_json,
                                            italic: val
                                        })
                                        setCount(pre => pre + 1)

                                    }}
                                >
                                    斜體
                                </Checkbox>
                            </Col>
                            <Col>
                                <Checkbox
                                    checked={getAnyFormValue("property_json.textDecoration", count)}
                                    onCheckedChange={(val) => {
                                        let property_json = getAnyFormValue("property_json", count)
                                        setFieldValue("property_json", {
                                            ...property_json,
                                            textDecoration: val
                                        })
                                        setCount(pre => pre + 1)

                                    }}
                                >
                                    底線
                                </Checkbox>
                            </Col>
                        </Row>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"左邊顏色"}
                        name={["property_json", "background_color1"]}
                    >
                        <ColorPicker
                            format={"hex"}
                            // value={colorData?.background_color1}
                            onChange={(e) => {
                                // setColorData((pre) => ({
                                //     ...pre,
                                //     background_color1: e.target.value,
                                // }))
                                let property_json = getAnyFormValue("property_json", count)
                                setFieldValue("property_json", {
                                    ...property_json,
                                    background_color1: e.target.value
                                })
                                setCount(pre => pre + 1)

                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={"右邊顏色"}
                        name={["property_json", "background_color2"]}
                    >
                        <ColorPicker
                            format={"hex"}
                            // value={colorData?.background_color2}
                            onChange={(e) => {
                                let property_json = getAnyFormValue("property_json", count)
                                setFieldValue("property_json", {
                                    ...property_json,
                                    background_color2: e.target.value
                                })
                                setCount(pre => pre + 1)
                            }}
                        ></ColorPicker>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={8}></Col>
                        <Col span={16}>
                            <Row
                                justify={"center"}
                                align="middle"
                                style={{
                                    backgroundImage: `linear-gradient(to right, ${getAnyFormValue("property_json.background_color1", count) || "#ffffff"}, #ffffff,
                                     ${getAnyFormValue("property_json.background_color2", count) || "#ffffff"})`,
                                    position: "relative",
                                    padding: 0,
                                }}
                            >
                                <Col span={24} style={{ textAlign: "center" }}>
                                    <div
                                        style={{
                                            fontSize: getAnyFormValue("property_json.size", count)
                                                ? `${getAnyFormValue("property_json.size", count)}px`
                                                : "3vmin",
                                            fontWeight: getAnyFormValue("property_json.blod", count)
                                                ? 900
                                                : "normal",
                                            fontStyle: getAnyFormValue("property_json.italic", count)
                                                ? "italic"
                                                : "normal",
                                            textDecoration:
                                                getAnyFormValue("property_json.textDecoration", count)
                                                    ? "underline"
                                                    : "none",
                                        }}
                                    >
                                        <div>
                                            {getAnyFormValue("name", count) || "測試文字"}

                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    };


    function updateClassifyStructureId(data,) {
        return data.map(item => {
            // 如果 classify_structure_type_parent_id 存在，將值賦給 classify_structure_id
            // 如果不存在，將 classify_structure_id 設為 0
            item.classify_structure_type_id = item.classify_structure_type_parent_id || 0;
            if (typeof item.property_json !== "object") {
                item.property_json = {}
            }
            item.property_json = JSON.stringify(item.property_json);
            // 如果有 children，遞迴處理子節點，並將結果回傳給 children
            if (item.children && item.children.length > 0) {
                item.children = updateClassifyStructureId(item.children);

            }
            // 回傳更新後的 item
            return item;
        });
    }
    const reorganizeFormData = (value, type) => {
        if (type === "submit") {
            let submitValues = { ...value };

            let permission_language_data = [
                {
                    language_culture_code: "zh-tw",
                    language_culture_value: submitValues?.name,
                },
                {
                    language_culture_code: "en",
                    language_culture_value: submitValues?.nameEn,
                },
            ];
            let classify_structure_type_id =
                submitValues?.classify_structure_type_id;
            if (!submitValues?.classify_structure_type_parent_id) {

            }
            if (
                !!submitValues?.["classify_structure_type_parent_id"] &&
                classify_structure_type_id !== 0
            ) {
                classify_structure_type_id =
                    submitValues?.classify_structure_type_parent_id;
            }
            let property_json = {
                ...submitValues?.property_json,
            };

            if (typeof property_json !== "object") {
                property_json = {}
            }

            let data = {
                ...submitValues,
                permission_language_data,
                classify_structure_type_id,
            }
            data = setParamsFilter(data)
            let newData = updateClassifyStructureId([data])
            let firstData = newData.find((ele) => true)
            return {
                ...firstData
            };
        } else if (type === "set") {
            let setValues = { ...value };
            let nameEn = (setValues?.permission_language_data || []).find(
                (ele) => {
                    return ele?.language_culture_code === "en";
                }
            )?.language_culture_value;
            setCount(pre => pre + 1)
            return {
                ...setValues,
                nameEn,
                path_check_replace: !!(setValues?.path_check === 1),
                show_replace: !!(setValues?.show === 1),
                blank_replace: !!(setValues?.blank === 1),
            };
        }
    };
    const {
        getPageManagementData,
        PageManagementData
    } = usePageManagement({
        onFinish: () => { },
        onBefore: () => { },
    });
    const {
        getMenuData,
        MenuData
    } = useMenu({
        onBefore: () => { },
        onFinish: () => { }
    })
    useEffect(() => {
        document.title = `${prefixTitle} | 選單項目設定`;
        getPageManagementData({})
        getMenuData({})
    }, [])
    useEffect(() => {
        if (!current_menu_id.current) {
            //若直接進入選單設定應預設顯示主選單的選單項目
            getMenuData({ major: 1 })
                .then((response) => {
                    let data = response?.data || []
                    let dataFirst = data.find(_ => true)
                    if (!!dataFirst) {
                        setSelectCurrentMenuId(dataFirst?.menu_id)
                        current_menu_id.current = dataFirst?.menu_id
                    }
                })
        }
        else {
            setForceReload(pre => pre + 1)
        }
    }, [current_menu_id.current])

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Typography.Title
                    level={3}
                >
                    選單項目設定
                </Typography.Title>

                <Row align="middle">
                    <Col >
                        目前編輯選單分類：
                    </Col>
                    <Col>
                        <Select
                            defaulDisabled={true}
                            // defaultValue={`${menu_id}`}
                            value={selectCurrentMenuId}
                            options={(
                                MenuData ||
                                []
                            ).map(
                                (
                                    value
                                ) => {
                                    return {
                                        label: getLanguageName(
                                            {
                                                language_culture_code:
                                                    "zh-tw",
                                                obj_language_data:
                                                    value?.name_language_data,
                                            }
                                        ),
                                        value: value?.menu_id
                                    };
                                }
                            )}

                            onChange={(value) => {
                                current_menu_id.current = value
                                setSelectCurrentMenuId(value)
                            }}
                        />
                    </Col>
                    <Col span={24}>

                        <ClassifyStructureNew
                            propsForm={form}
                            prefixTitle="permission"
                            apiRoute="/dynamicWebsite/backend/permission"
                            customColumns={[
                                {
                                    title: "中文名稱",
                                    key: "permission_language_data_tw",
                                    dataIndex: "permission_language_data",
                                    render: (text, record, index) =>
                                        (
                                            record?.permission_language_data || []
                                        )?.find(
                                            (tmp) =>
                                                tmp?.language_culture_code ===
                                                "zh-tw"
                                        )?.language_culture_value || "-",
                                },
                                {
                                    title: "英文名稱",
                                    key: "permission_language_data_en",
                                    dataIndex: "permission_language_data",
                                    render: (text, record, index) =>
                                        (
                                            record?.permission_language_data || []
                                        )?.find(
                                            (tmp) =>
                                                tmp?.language_culture_code === "en"
                                        )?.language_culture_value || "-",
                                },
                                {
                                    title: "內/外部連結",
                                    dataIndex: "path_check",
                                    key: "path_check",
                                    render: (text, record, index) => (
                                        <>{text === 1 ? "外部" : "內部"}</>
                                    ),
                                },
                                {
                                    title: "副標題",
                                    dataIndex: "subheading",
                                    key: "subheading",
                                },
                                {
                                    title: "綁定頁面",
                                    dataIndex: "permission_page_data",
                                    key: "permission_page_data",
                                    render: (text, record, index) => {
                                        let finalData = [];
                                        let permission_page_data =
                                            record?.permission_page_data || [];
                                        permission_page_data.forEach((element) => {
                                            let pageNameLanguageData =
                                                element?.name_language_data || [];
                                            let pageTwName =
                                                (pageNameLanguageData || [])?.find(
                                                    (tmp) =>
                                                        tmp?.language_culture_code ===
                                                        "zh-tw"
                                                )?.language_culture_value || "-";
                                            let pageEnName =
                                                (pageNameLanguageData || [])?.find(
                                                    (tmp) =>
                                                        tmp?.language_culture_code ===
                                                        "en"
                                                )?.language_culture_value || "-";
                                            finalData.push(
                                                `${pageTwName}(${pageEnName})`
                                            );
                                        });

                                        return (
                                            <Row>
                                                {finalData.map((ele) => {
                                                    return <Col>{ele}</Col>;
                                                })}
                                            </Row>
                                        );
                                    },
                                },

                            ]}
                            customFormItems={() => {
                                return formItemsRender();
                            }}
                            reorganizeFormData={reorganizeFormData}
                            classify_structure_id={5}
                            classify_structure_type_id={0}
                            initialValues={{
                                permission_id: null,
                                path_check: 0,
                                path_check_replace: false,
                                show_replace: false,
                                show: 0,
                                menu_permission_data: [{
                                    menu_id: current_menu_id?.current
                                }],
                                property_json: {
                                    blod: false,
                                    italic: false,
                                    textDecoration: false,
                                    background_color1: null,
                                    background_color2: null
                                }

                            }}
                            extraParams={{
                                menu_id: current_menu_id.current
                            }}
                            forceReload={forceReload}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};
export default RouteSetting;


